import React from "react";
import img2 from "../../../images/featured/right-on-time.webp";
import img1 from "../../../images/featured/right-skills.webp";
import img3 from "../../../images/featured/rightcost.webp";
function WorkWithMe() {
  return (
    <div className="about-work-with-me ">
      <div className="margin_container">
        <div className="top-section">
          <h1>Why Work With Me</h1>
          <p>You can decide whether to hire your developer</p>
        </div>
        <div className="items">
          <div className="left">
            <h1>Right on Skills</h1>
            <p>
              I am highly experienced in web development fields. In addition to
              my core skills, I experienced in collaboration, distributed
              development.
              <br /> <br /> I offer fixed-price, time and material as well as
              risk-sharing hybrid project setups. 
              Do you require a specialist skill? Just ask me. I am ready to
              collaboration with you right now.
            </p>
          </div>
          <div className="right">
            <img src={img1} alt="" />
          </div>
        </div>
        <br /> <br /> <br /> <br />
        <div className="items">
          <div className="left order-1">
            <img src={img2} alt="" />
          </div>
          <div className="right order-2">
            <h1>Right on Time</h1>
            <p>
              Time is money. I help you manage your development capacity
              effectively, scale up and down to meet your project deadlines.
              <br /> <br />
              Trusting on me , you can control your operating costs with
              improved productivity. Don't worry about loss of know-how when you
              scale down.I have experience and solution offerings for flexible
              workloads.
            </p>
          </div>
        </div>
        <br /> <br /> <br /> <br />
        <div className="items">
          <div className="left">
            <h1>Right on Cost</h1>
            <p>
              Relying on nearshore development teams, My clients reduce their
              development costs on aeverage by 60%. While you focus on your core
              competencies with your flexible and affordable team, <br />
              <br /> I take care
              of full administration, people management, infrastructure, and
              training costs of team members.
            </p>
          </div>
          <div className="right">
            <img src={img3} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkWithMe;
